import { useState, useEffect } from 'react'
import { Avatar, Button } from 'dsm-react-lib'
import { IconCheck, IconBookmark } from '@tabler/icons-react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { appInsights } from '../../_services/AppInsights'
import { EventType } from '../../utility/types'
import { useTrackEvent } from '@microsoft/applicationinsights-react-js'
import { useAppsService } from '../../_services/_index'
import { ButtonSpinner } from '../../styles/common'
import { useSasToken } from '../../_hooks/useSasToken'

export const ItemContainer = styled.div`
  display: flex;
  display: inline-block;
  width: 100% !important;
  height: 220px;
  background: var(--surface-bg);

  border: 1px solid var(--surface-muted);
  border-radius: 2px;
  margin-bottom: 20px;

  @media screen and (min-width: 1000px) and (max-width: 1399px) {
    height: 260px;
  }
`

export const CardContainer = styled.div``
export const HeaderContainer = styled.div`
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`

export const TitleAppsSearch = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  margin: 10px 0 0 20px;
  color: var(--text-heading);

  @media (max-width: 1600px) and (min-width: 1401px) {
    font-size: 16px;
  }
`
/*   @media (max-width: 1600px) and (min-width: 1401px) {
    margin: 30px 10px 0 40px;
  }

  @media (max-width: 1400px) {
    padding-left: 25px;
  } */

export const CategoryAppsSearch = styled.div`
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  margin: 0.5rem 0.5rem 0.5rem 1.5rem;
  color: var(--text-heading);

  /*  @media (max-width: 1600px) {
    margin: 10px 40px;
  } */
`
export const DescAppsSearch = styled.div`
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  margin: 0 20px 20px 20px;
  color: var(--text-body);
  opacity: 70%;

  @media (max-width: 1600px) and (min-width: 1401px) {
    font-size: 12px;
  }
`
export const IconContainer = styled.div`
  padding: 0;
`

const CTAWrapper = styled.div`
  margin: 20px;
`

const CardApplication = ({ item, appsInWorkspace }) => {
  const { addingApplication, addApplication, removingApplication, removeApplication } =
    useAppsService()
  const { appendToken } = useSasToken()
  const [foundAppInWorkspace, setFoundAppInWorkspace] = useState(false)
  const trackAddToWorkspace = useTrackEvent(appInsights, EventType.AddToWorkspace)

  const {
    name,
    description,
    shortDescription,
    applicationIcon = item?.appIcon && Object.keys(item?.appIcon)?.length
      ? item?.appIcon?.url
      : item?.appIcon,
    uniqueName
  } = item || {}

  useEffect(() => {
    const fetchApp = async () => {
      const foundApp = await appsInWorkspace?.find((appWorkspace) => appWorkspace.id === item?.id)
      setFoundAppInWorkspace(!!foundApp)
    }
    fetchApp()
  }, [appsInWorkspace])

  if (item === null || item === undefined || Object.keys(item).length === 0) {
    return null
  }

  const addToWorkspace = async (item) => {
    trackAddToWorkspace({ appAdd: JSON.stringify(item) })
    const response = foundAppInWorkspace
      ? await removeApplication(item)
      : await addApplication(item)

    if (response?.status === 0) {
      setFoundAppInWorkspace((foundAppInWorkspace) => !foundAppInWorkspace)
    }
  }

  const getIcon = () => {
    if (foundAppInWorkspace) {
      return removingApplication ? <ButtonSpinner color="white" /> : <IconCheck size={16} />
    } else {
      return addingApplication ? <ButtonSpinner color="white" /> : <IconBookmark size={16} />
    }
  }

  return (
    <>
      <ItemContainer>
        <CardContainer>
          <HeaderContainer>
            <IconContainer>
              <Link
                to={{
                  pathname: `/apps/${uniqueName}`,
                  state: {
                    from: location.pathname
                  }
                }}>
                <Avatar
                  content={appendToken(applicationIcon)}
                  size="74px"
                  alt={name}
                  shape="rounded"
                />
              </Link>
            </IconContainer>
            <div>
              <Link
                to={{
                  pathname: `/apps/${uniqueName}`,
                  state: {
                    from: location.pathname
                  }
                }}>
                <TitleAppsSearch>{name}</TitleAppsSearch>
              </Link>
              <CategoryAppsSearch>
                {item.applicationInCategories?.map((appCategory, index) => {
                  return (
                    <Link to={`/categories/view/${appCategory.category.uniqueName}`} key={index}>
                      {appCategory.category.name}
                      {index !== item.applicationInCategories.length - 1 ? ' | ' : ''}
                    </Link>
                  )
                })}
              </CategoryAppsSearch>
            </div>
          </HeaderContainer>
          <DescAppsSearch>
            {shortDescription ? shortDescription : description.substring(0, 100)}
          </DescAppsSearch>
          <CTAWrapper>
            <Button
              label={foundAppInWorkspace ? 'Added' : 'Add'}
              color={foundAppInWorkspace ? 'success' : 'primary'}
              variant={foundAppInWorkspace ? 'fill' : 'outline'}
              className={`btn-sm text-center   ${
                !foundAppInWorkspace ? 'btn-custom-hover' : 'btn-success'
              }`}
              size="small"
              icon={getIcon()}
              id={`btn-item-${item.id}`}
              onClick={() => addToWorkspace(item)}
              data-testid={`mediaAppBtn-${item.id}`}></Button>
          </CTAWrapper>
        </CardContainer>
      </ItemContainer>
    </>
  )
}

export default CardApplication
